// This code overrides TinyMCE's default menu and tooltip behavior to prevent them from being appended to the body
// Instead, it attaches them to their respective buttons/toolbar items
tinymce.on('AddEditor', function(e) {
  var editor = e.editor;
  
  // Wait for editor to be fully initialized before applying our overrides
  editor.on('init', function() {
    // Debugger timeout - helps in debugging the initialization
    // setTimeout(function() {debugger}, 2000)

    // Store original DOM methods so we can restore them later
    // This is important for cleanup and to prevent memory leaks
    var originalAppendChild = document.body.appendChild;
    var originalInsertBefore = document.body.insertBefore;
    var originalCreateElement = document.createElement;

    // Helper function to identify TinyMCE menu and tooltip elements
    // Checks if an element has any of the TinyMCE 4.x specific classes
    function isTinyMCEElement(element) {
      if (!element || !element.className) return false;
      
      var classes = element.className.split(' ');
      return classes.some(function(className) {
        // Check for exact matches and partial matches of TinyMCE 4.x classes
        return className === 'mce-menu' ||
               className === 'mce-tooltip' ||
               className.includes('mce-menu') ||
               className.includes('mce-tooltip');
      });
    }

    // Helper function to find where a menu or tooltip should be attached
    // Returns the appropriate target element (button for menus, toolbar item for tooltips)
    function findTargetElement(element) {
      if (!element || !element.className) return null;
      
      var editorContainer = editor.getContainer();
      if (!editorContainer) return null;

      var classes = element.className.split(' ');
      // Check if this is a menu element
      var isMenu = classes.some(function(className) {
        return className === 'mce-menu' || className.includes('mce-menu');
      });
      // Check if this is a tooltip element
      var isTooltip = classes.some(function(className) {
        return className === 'mce-tooltip' || className.includes('mce-tooltip');
      });

      // For menus: find the button that triggered the menu (has aria-expanded="true")
      if (isMenu) {
        var button = editorContainer.querySelector('.mce-btn[aria-expanded="true"]');
        if (button) {
          return button;
        }
      }

      // For tooltips: find the toolbar item that's being hovered
      if (isTooltip) {
        var target = editorContainer.querySelector('.mce-btn:hover, .mce-toolbar-item:hover');
        if (target) {
          return target;
        }
      }

      return null;
    }

    // Override createElement to catch TinyMCE elements as they're created
    // This helps prevent them from being added to the body
    document.createElement = function(tagName) {
      var element = originalCreateElement.call(this, tagName);
      
      // Use setTimeout to check the element after TinyMCE has finished setting it up
      setTimeout(function() {
        if (isTinyMCEElement(element) && element.parentNode === document.body) {
          var target = findTargetElement(element);
          if (target) {
            target.appendChild(element);
          }
        }
      }, 0);

      return element;
    };

    // Override appendChild to intercept when TinyMCE tries to add elements to the body
    document.body.appendChild = function(element) {
      if (isTinyMCEElement(element)) {
        var target = findTargetElement(element);
        if (target) {
          return target.appendChild(element);
        }
      }
      return originalAppendChild.call(this, element);
    };

    // Override insertBefore to intercept when TinyMCE tries to insert elements into the body
    document.body.insertBefore = function(element, referenceNode) {
      if (isTinyMCEElement(element)) {
        var target = findTargetElement(element);
        if (target) {
          return target.insertBefore(element, target.firstChild);
        }
      }
      return originalInsertBefore.call(this, element, referenceNode);
    };

    // Create a MutationObserver to catch any elements that might slip through our overrides
    // This is a backup mechanism to ensure no TinyMCE elements end up in the body
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1 && isTinyMCEElement(node) && node.parentNode === document.body) {
              var target = findTargetElement(node);
              if (target) {
                target.appendChild(node);
              }
            }
          });
        }
      });
    });

    // Start observing the body for any TinyMCE elements being added
    observer.observe(document.body, {
      childList: true,  // Watch for changes to the direct children
      subtree: false    // Don't watch the entire subtree, just direct children
    });

    // Handle clicks outside menus to close them
    // This ensures menus close when clicking elsewhere on the page
    function handleClickOutside(e) {
      var editorContainer = editor.getContainer();
      if (!editorContainer) return;

      // Check if click was inside a menu or button
      var isClickInsideMenu = e.target.closest('.mce-menu, [class*="mce-menu"]');
      var isClickInsideButton = e.target.closest('.mce-btn');
      
      // If click was outside both menu and button, close any open menu
      if (!isClickInsideMenu && !isClickInsideButton) {
        var activeButton = editorContainer.querySelector('.mce-btn[aria-expanded="true"]');
        if (activeButton) {
          // Just hide the menu instead of removing it
          activeButton.setAttribute('aria-expanded', 'false');
          var menu = activeButton.querySelector('.mce-menu, [class*="mce-menu"]');
          if (menu) {
            menu.style.display = 'none';
            // Don't remove the menu from DOM
            // if (menu.parentNode) {
            //   menu.parentNode.removeChild(menu);
            // }
          }
        }
      }
    }

    // Add click handler to document
    // Using capture phase (true) to ensure we handle the click before TinyMCE
    document.addEventListener('mousedown', handleClickOutside, true);

    // Add our custom CSS to style the menus and tooltips
    var style = document.createElement('style');
    style.textContent = 
      /* Style for menus - position them below their buttons */
      '.mce-toolbar-grp [class*="mce-menu"] {' +
        'position: absolute !important;' +
        'top: 100% !important;' +
        'left: 0 !important;' +
        'z-index: 10000 !important;' +
        'margin-top: 0 !important;' +
        'visibility: visible !important;' +
      '}' +
      
      /* Style for menu items */
      '.mce-toolbar-grp [class*="mce-menu-item"] {' +
        'display: block !important;' +
        'cursor: pointer !important;' +
        'position: relative !important;' +
        'white-space: nowrap !important;' +
      '}' +
      
      /* Style for tooltips - position them below their items */
      '.mce-toolbar-grp .mce-tooltip {' +
        'position: absolute !important;' +
        'top: 100% !important;' +
        'left: 50% !important;' +
        'transform: translateX(-50%) !important;' +
      '}' +
      /* Ensure tooltip text doesn't wrap */
      '.mce-toolbar-grp .mce-tooltip-inner {' +
        'white-space: nowrap !important;' +
      '}' +

      /* Make buttons relative for proper menu positioning */
      '.mce-toolbar-grp .mce-btn {' +
        'position: relative !important;' +
      '}';
    document.head.appendChild(style);

    // Cleanup function - restore original DOM methods when editor is removed
    // This prevents memory leaks and ensures other code isn't affected
    editor.on('remove', function() {
      // Restore original DOM methods
      document.createElement = originalCreateElement;
      document.body.appendChild = originalAppendChild;
      document.body.insertBefore = originalInsertBefore;
      // Remove our event listener
      document.removeEventListener('mousedown', handleClickOutside, true);
      // Disconnect the observer
      observer.disconnect();
    });
  });
}); 


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/custom-external-script/tinymce/core-overrides.js
// module id = 472
// module chunks = 0